<app-segov-sigepo-portal-body>
  <app-segov-sigepo-header-section [RouteStack]="RouteStack" [Title]="titulo" />

  <div class="container-calendario-legenda">
    <h3 class="default-spacing-title titulo-geral">Calendário de Publicações do
      <br>Diário Oficial Eletrônico Minas Gerais</h3>

    <div class="row default-spacing-title" style="margin: 0; padding-bottom: 4rem;">
      <div class="col-lg-8 col-12 coluna-calendario" style="margin:auto">
        <app-calendar [Cronogramas]="Cronogramas" [LimiteMinData]="LimiteMinData" [LimiteMaxData]="LimiteMaxData"
          [ObterDataUltimaEdicao]="false"
          [ExibirLegendaPadrao]="false" [customIconStyle]="'color: white'" [TipoCalendario]="TipoCalendario"
          [textoNavegaDiaAtual]="'Mês atual'" (alternarMes)="onMudancaDeMes($event)" />
      </div>
      <div class="col-lg-4 col-12 informacoes-card">
        <div class="mt-4 mt-lg-0">
          <h5 style="color: var(--tom-2-informativo)">Atualizado em: {{dadosCalendario.dataAtualizacao | date:
            'dd/MM/yyyy'}}</h5>
          <p>Este calendário contém a programação da publicação das edições ordinárias do Jornal Minas Gerais, que ocorre de terça-feira a sábado, com base nos feriados e pontos facultativos estabelecidos para o ano corrente. Por essa razão, não são exibidas nesta seção quaisquer informações sobre as edições extraordinárias.</p>
          <p>A lista de feriados e pontos facultativos poderá ser consultada clicando nos links abaixo:</p>
          <ul>
            @for(data of dadosCalendario.datasPublicacoesComunicadosCalendario; track $index){
            <li style="cursor: pointer; text-decoration: underline;" tabindex="0"
              (click)="obterDataComunicadoEMudarPagina(data)" (keyup.enter)="obterDataComunicadoEMudarPagina(data)">
              Comunicado de {{data | date: 'dd/MM/yyyy'}}</li>
            }
          </ul>
        </div>
        <div>
          <h5 style="color: var(--tom-2-informativo)">Legenda</h5>
          <span style="display: flex;">
            <div class="icone-legenda" style="background-color: var(--cal-tela-publicacao-com-publicacao);"></div>
            Publicação normal no dia
          </span>
          <span style="display: flex;">
            <div class="icone-legenda" style="background-color: var(--cal-tela-publicacao-sem-publicacao);"></div> Sem
            publicação
          </span>
        </div>
      </div>
    </div>
  </div>

</app-segov-sigepo-portal-body>
